import React from "react";
import { InputText } from "primereact/inputtext";
import { FaRegQuestionCircle } from "react-icons/fa";
import { useField } from "formik";

const FormikInputField = ({
  placeholder = "",
  label = "",
  name = "",
  className = "",
  isIcon = false,
  icon,
  iconPos = "left",
  iconClassName = "",
  defaultValue = "",
  type = "text",
  NavigationIcon,
  onIconClick = () => { },
  parentClass = "",
  tooltipMessage = "",
  hideErrorText = false,
  ...props
}) => {
  const [field, meta] = useField(name);

  const isInvalid = meta.error && meta.touched;

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`}>
      {label && (
        <div className="flex items-center justify-between">
          <label
            htmlFor={name}
            className="input-label flex items-center gap-x-2"
          >
            {label}
            {tooltipMessage !== "" && (
              <FaRegQuestionCircle
                size={12}
                title={tooltipMessage}
                className="text-gray-900 cursor-pointer"
              />
            )}
          </label>
          {NavigationIcon && (
            <NavigationIcon
              size={17}
              className="text-iconC cursor-pointer"
              onClick={onIconClick}
            />
          )}
        </div>
      )}

      <InputText
        id={name}
        placeholder={placeholder}
        type={type}
        autoComplete="off"
        {...(type === "number" ? { min: 0 } : {})}
        {...field}
        {...props}
        className={`input-field ${className} ${isInvalid && hideErrorText ? "!border-red-500" : ""}`}
      />
      {isInvalid && !hideErrorText && (
        <p className="text-sm text-red-500">{meta.error}</p>
      )}
    </div>
  );
};

// Standalone component
const StandaloneInputField = ({
  placeholder = "",
  label = "",
  name = "",
  className = "",
  iconClassName = "",
  value = "",
  type = "text",
  parentClass = "",
  tooltipMessage = "",
  handleChange = () => { },
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`}>
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
          {tooltipMessage !== "" && (
            <FaRegQuestionCircle
              size={12}
              title={tooltipMessage}
              className="text-gray-900 cursor-pointer"
            />
          )}
        </label>
      )}
      <InputText
        id={name}
        name={name}
        placeholder={placeholder}
        type={type}
        value={value}
        autoComplete="off"
        onChange={handleChange}
        {...(type === "number" ? { min: 0 } : {})}
        {...props}
        className={`input-field ${className}`}
      />
    </div>
  );
};

// wrapper
const TextInput = (props) => {
  const { useFormik = true } = props;

  if (useFormik) {
    return <FormikInputField {...props} />;
  }

  return <StandaloneInputField {...props} />;
};

export default TextInput;
